import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IactRoutingModule } from './iact-routing.module';
import { IactComponent } from './iact.component';
import { DefinitionComponent } from './definition/definition.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IacctListComponent } from './iact-list/iact-list.component';
import { NoCommaPipe } from 'src/app/shared/no-comma.pipe';
import { IactListIndexComponent } from './iact-list/iact-list-index.component';
import { ExternalComponent } from './external/external.component';
import { AcquisitionsComponent } from './acquisitions/acquisitions.component';

@NgModule({
  declarations: [IactComponent, DefinitionComponent, IacctListComponent, IactListIndexComponent, ExternalComponent, NoCommaPipe, AcquisitionsComponent],
  imports: [CommonModule, IactRoutingModule, SharedModule],
})
export class IactModule {}
